import React, { useState,useRef } from "react";
import { useTypewriter} from "react-simple-typewriter";
import { toast } from "react-toastify";
import emailjs from '@emailjs/browser';

import imgBack from "../../../src/images/mailz.jpeg";
import load1 from "../../../src/images/load2.gif";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./ContactMe.css";

export default function ContactMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [banner, setBanner] = useState("");
  const [bool, setBool] = useState(false);

  const handleName = (e) => {
    setName(e.target.value);
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handleMessage = (e) => {
    setMessage(e.target.value);
  };
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setBool(true);
    if (name.length === 0 || email.length === 0 || message.length === 0) 
    {
      toast.error("Please Fill All The Fields!")
      setBanner("Please Fill All The Fields!");
      setBool(false);
    }
    else{
    emailjs.sendForm('service_3wbnr3i', 'template_id05l1u', form.current, 'BCxr89e_L1BGlaJHR')
      .then((result) => {
          toast.success("Thank You For Contacting Peter.");
          setBanner("Thank You For Contacting Peter.");
          setBool(false);
          setName("");
          setEmail("");
          setMessage("");
      }, (error) => {
          toast.error("There is server error");
          setBool(false);
      });
    }
  };

  const [typeEffect] = useTypewriter({
    words: [
      "Get In Touch 🤝",
      "Connect with Me 📱",
      "Send a Message 📧",
      "Get You Job Done ✅"
    ],
    loop: {},
    typeSpeed: 100,
    deleteSpeed: 60,
  });

  return (
    <div className="main-container fade-in" id={props.id || ""}>
      <ScreenHeading subHeading={"Lets Keep In Touch"} title={"Contact Me"} />
      <div className="central-form">
        <div className="col">
          <h2 className="title">
          📬
            {typeEffect}
          </h2>{" "}
          <a href="https://www.facebook.com/peter.mmdoh">
            <i className="fa fa-facebook-square" />
          </a>
          <a href="https://github.com/peterM65?tab=repositories">
            <i className="fa fa-github" />
          </a>
          <a href="https://www.linkedin.com/in/peter-mamdouh-fullstack/">
            <i className="fa fa-linkedin-square" />
          </a>
        </div>
        <div className="back-form">
          <div className="img-back">
            <h4>Send Your Email Here!</h4>
            <img src={imgBack} alt="image not found" />
          </div>
          <form ref={form} onSubmit={sendEmail}>
            <p>{banner}</p>
            <label htmlFor="name">Name</label>
            <input type="text" onChange={handleName}  name="user_name" value={name} />

            <label htmlFor="email">Email</label>
            <input type="email" onChange={handleEmail} name="user_email" value={email} />

            <label htmlFor="message">Message</label>
            <textarea onChange={handleMessage}  name="message" value={message} />

            <div className="send-btn">
              <button type="submit">
                send
                <i className="fa fa-paper-plane" />
                {bool ? (
                  <b className="load">
                    <img src={load1} alt="image not responding" />
                  </b>
                ) : (
                  ""
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
